module.exports = __webpack_public_path__ + "./assets/17950124d3e113206f1618b1a6c01180.woff";